import { FC, MouseEvent } from 'react'
import { IconButton, MenuItem } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import theme from 'theme'

/* Components */
import { MarkMenu } from '../listToolbar.styles'

interface Props {
  markMenuOpen: boolean
  anchorEl: null | HTMLElement
  handleClick: (event: MouseEvent<HTMLElement>) => void
  handleClose: () => void
  markMenuOptions: string[]
  handleMarkMenuOption: (option: string) => void
}

const MarkReadMenu: FC<Props> = ({
  markMenuOptions,
  markMenuOpen,
  handleMarkMenuOption,
  handleClick,
  handleClose,
  anchorEl
}) => {
  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={markMenuOpen ? 'long-menu' : undefined}
        aria-expanded={markMenuOpen ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        sx={{
          color: markMenuOpen ? theme.colors.textSecondary : theme.colors.cta,
          background: markMenuOpen ? theme.colors.analyzerIconActive : '',
          '&:hover': {
            background: theme.colors.analyzerIconHover,

            svg: {
              path: {
                fill: theme.colors.analyzerIconActive
              }
            }
          },
          "html[data-theme='light'] &": {
            '&:hover': {
              background: 'transparent',
              svg: { path: { fill: '#c477c1' } }
            },
            '&:focus': {
              svg: { path: { fill: theme.colors.buttonHollowFocus } }
            },
            '&.Mui-disabled': {
              svg: { path: { fill: theme.colors.btnSecondaryDisabledText } }
            }
          }
        }}
      >
        <MoreVertIcon
          sx={{
            path: {
              fill: markMenuOpen ? theme.colors.foreground : theme.colors.cta
            }
          }}
        />
      </IconButton>
      <MarkMenu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button'
        }}
        anchorEl={anchorEl}
        open={markMenuOpen}
        onClose={handleClose}
        sx={{
          '.MuiPaper-root': {
            marginTop: '5px',
            borderRadius: theme.attributes.borderRadius.small,
            width: '200px',
            maxHeight: '98px',
            border: `1px solid ${theme.colors.strokePrimary}`,
            background: theme.colors.frameworkCardBg,
            padding: 0,

            "html[data-theme='light'] &": {
              boxShadow: '0 4px 8px 0 rgba(162, 145, 158, 0.20)'
            },

            '.MuiList-root': {
              padding: `${theme.spacing.xSmall}px`,

              '.MuiMenuItem-root': {
                borderRadius: theme.attributes.borderRadius.small,
                height: '40px',
                overflow: 'hidden',
                color: theme.colors.foreground,
                textOverflow: 'ellipsis',
                fontSize: theme.typography.fontSize.xLarge,
                fontStyle: 'normal',
                fontWeight: theme.typography.fontWeight.normal,
                lineHeight: 'normal',
                padding: `0 ${theme.spacing.xSmall}px`,

                '&:hover': {
                  background: theme.colors.tooltipBg,

                  "html[data-theme='light'] &": {
                    background: theme.colors.menuItemHover
                  }
                },

                '&.Mui-selected, &.Mui-focusVisible': {
                  "html[data-theme='light'] &": {
                    background: theme.colors.cardFillTertiary
                  }
                }
              }
            }
          }
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        {markMenuOptions.map((option) => (
          <MenuItem key={option} onClick={() => handleMarkMenuOption(option)}>
            {option}
          </MenuItem>
        ))}
      </MarkMenu>
    </div>
  )
}

export default MarkReadMenu
